export default {
  imoveisEmDestaque: state => state.imoveisEmDestaque,
  imovel: state => state.imovel,
  planos: state => state.planos,
  favoritos: state => state.favoritos,
  imoveisFavoritos: state => state.imoveisFavoritos
}
